import { useTranslation } from 'react-i18next'
import { PhoneInput } from 'react-international-phone'
import 'react-international-phone/style.css'

export default function ShuttleServiceFormFields({ formik, countries }) {
    const { t } = useTranslation()

    return (
        <>
            {/* Provider Information */}
            <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Provider Information')}</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">
                        {t('Enter the shuttle service provider details')}
                    </p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                    <div className="sm:col-span-6">
                        <label htmlFor="provider_name" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Provider Name')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="provider_name"
                                name="provider_name"
                                type="text"
                                value={formik.values.provider_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter provider name"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.provider_name && formik.errors.provider_name && (
                                <p className="text-error text-xs mt-1">{formik.errors.provider_name}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="service_description_en" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Service Description (English)')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="service_description_en"
                                name="service_description_en"
                                type="text"
                                value={formik.values.service_description_en}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter English description"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.service_description_en && formik.errors.service_description_en && (
                                <p className="text-error text-xs mt-1">{formik.errors.service_description_en}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="service_description_ar" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Service Description (Arabic)')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="service_description_ar"
                                name="service_description_ar"
                                type="text"
                                value={formik.values.service_description_ar}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter Arabic description"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.service_description_ar && formik.errors.service_description_ar && (
                                <p className="text-error text-xs mt-1">{formik.errors.service_description_ar}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Information */}
            <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Contact Information')}</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">
                        {t('Contact details for the shuttle service provider')}
                    </p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                    <div className="sm:col-span-6">
                        <label htmlFor="contact_person" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Contact Person')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="contact_person"
                                name="contact_person"
                                type="text"
                                value={formik.values.contact_person}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter contact person name"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.contact_person && formik.errors.contact_person && (
                                <p className="text-error text-xs mt-1">{formik.errors.contact_person}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="contact_mobile_number" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Mobile Number')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <PhoneInput
                                defaultCountry="bh"
                                value={formik.values.contact_mobile_number}
                                onChange={phone => formik.setFieldValue('contact_mobile_number', phone)}
                                onBlur={() => formik.setFieldTouched('contact_mobile_number', true)}
                                inputClassName="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.contact_mobile_number && formik.errors.contact_mobile_number && (
                                <p className="text-error text-xs mt-1">{formik.errors.contact_mobile_number}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="contact_email" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Email')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="contact_email"
                                name="contact_email"
                                type="email"
                                value={formik.values.contact_email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter email address"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.contact_email && formik.errors.contact_email && (
                                <p className="text-error text-xs mt-1">{formik.errors.contact_email}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-6">
                        <label htmlFor="contact_address" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Address')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <textarea
                                id="contact_address"
                                name="contact_address"
                                rows={3}
                                value={formik.values.contact_address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Enter address"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.contact_address && formik.errors.contact_address && (
                                <p className="text-error text-xs mt-1">{formik.errors.contact_address}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-6">
                        <label htmlFor="country_code" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Country')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <select
                                id="country_code"
                                name="country_code"
                                value={formik.values.country_code}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            >
                                <option value="">{t('Select Country')}</option>
                                {(countries || []).map(country => {
                                    const value = country.code || country.alpha_iso2
                                    const label = country?.name?.en || country?.name || country.country || value
                                    return (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                    )
                                })}
                            </select>
                            {formik.touched.country_code && formik.errors.country_code && (
                                <p className="text-error text-xs mt-1">{formik.errors.country_code}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Pricing Information */}
            <div className="grid grid-cols-1 gap-x-8 gap-y-4 border-b border-gray-900/10 pb-5 md:grid-cols-3">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Pricing Information')}</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">{t('Set the pricing for the shuttle service')}</p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                    <div className="sm:col-span-2">
                        <label htmlFor="price_base" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Base Price')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="price_base"
                                name="price_base"
                                type="number"
                                step="0.01"
                                value={formik.values.price_base}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="0.00"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.price_base && formik.errors.price_base && (
                                <p className="text-error text-xs mt-1">{formik.errors.price_base}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-2">
                        <label htmlFor="price_tax" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Tax')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <input
                                id="price_tax"
                                name="price_tax"
                                type="number"
                                step="0.01"
                                value={formik.values.price_tax}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="0.00"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            />
                            {formik.touched.price_tax && formik.errors.price_tax && (
                                <p className="text-error text-xs mt-1">{formik.errors.price_tax}</p>
                            )}
                        </div>
                    </div>

                    <div className="sm:col-span-2">
                        <label htmlFor="price_currency" className="block text-sm font-medium leading-6 text-gray-900">
                            {t('Currency')}
                            <span className="text-red">*</span>
                        </label>
                        <div className="mt-2">
                            <select
                                id="price_currency"
                                name="price_currency"
                                value={formik.values.price_currency}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                            >
                                <option value="BHD">BHD</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                                <option value="AED">AED</option>
                                <option value="SAR">SAR</option>
                                <option value="QAR">QAR</option>
                            </select>
                            {formik.touched.price_currency && formik.errors.price_currency && (
                                <p className="text-error text-xs mt-1">{formik.errors.price_currency}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Status */}
            <div className="grid grid-cols-1 gap-x-8 gap-y-4 md:grid-cols-3">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">{t('Status')}</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">{t('Set the active status')}</p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6 md:col-span-2">
                    <div className="sm:col-span-6">
                        <div className="flex items-center gap-3">
                            <input
                                id="isactive"
                                name="isactive"
                                type="checkbox"
                                checked={formik.values.isactive}
                                onChange={formik.handleChange}
                                className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
                            />
                            <label htmlFor="isactive" className="text-sm font-medium leading-6 text-gray-900">
                                {t('Active')}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
